window.addEventListener('load', function() {
  const header = document.querySelector('store-header');
  if (!header) return;

  const style = document.createElement('style');
  style.textContent = `
    store-header {
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      z-index: 100 !important;
    }
    store-header.header--shrunk {
      background: transparent !important;
      box-shadow: none !important;
      backdrop-filter: none !important;
      padding: 4px 16px !important;
    }
    store-header.header--shrunk .header__wrapper {
      max-width: 90% !important;
      margin: 0 auto !important;
      border-radius: 50px !important;
      background: white !important;
      box-shadow: 0 12px 60px rgba(0,0,0,0.7) !important;
      padding: 2px 24px !important;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    }
  `;
  document.head.appendChild(style);

  document.body.style.paddingTop = header.offsetHeight + 'px';

  window.addEventListener('scroll', function() {
    if (window.scrollY > 80) {
      header.classList.add('header--shrunk');
    } else {
      header.classList.remove('header--shrunk');
    }
  }, { passive: true });
});
